import { render, staticRenderFns } from "./CustomizeTree.vue?vue&type=template&id=55212de4&"
import script from "./CustomizeTree.vue?vue&type=script&lang=js&"
export * from "./CustomizeTree.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports